import React from 'react';
import ReactDOM from 'react-dom';
import './styles/globals.css';
import App from './App';
import reportWebVitals from './helpers/reportWebVitals';
import { Provider } from 'mobx-react';
import siaStore from './stores/siaStore';
import userStore from './stores/userStore';
import settingsStore from './stores/settingsStore';

ReactDOM.render(
    <React.StrictMode>
        <Provider siaStore={siaStore} userStore={userStore} settingsStore={settingsStore}>
            <App />
        </Provider >
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
